import { Box, Icon, Text } from '@fairfashion/design-system'

import * as Styles from './product-item.styles'
import { ProductItemProps } from './product-item.types'

export const ProductItem = ({ item, selected, onSelect }: ProductItemProps) => {
  return (
    <Styles.Container
      width="100%"
      paddingX={3}
      paddingY={2}
      position="relative"
      direction="column"
      onClick={onSelect ? () => onSelect(item) : undefined}
      selected={selected}
    >
      <Styles.OneLineText textTransform="capitalize" fontWeight={500}>
        {item?.description}
      </Styles.OneLineText>
      <Styles.OneLineText size="small" textTransform="capitalize">
        {item?.providerName}
      </Styles.OneLineText>
      <Box gap={1}>
        {item.createDate && <Icon name="calendar" color="grey_3" size={16} />}
        <Text size="small" color="grey_3">
          {item.createDate
            ? new Date(item?.createDate).toLocaleDateString()
            : ''}
        </Text>
      </Box>
      <Box justifyContent="space-between" width="100%">
        <Box gap={1}>
          {item.invoiceCode && <Icon name="receipt" color="grey_3" size={16} />}
          {item.invoiceCode && (
            <Text size="small" color="grey_3">
              NF {item?.invoiceCode}
            </Text>
          )}
        </Box>
        <Text size="small" color="grey_3">
          {item?.quantity} {item?.taxUnit}
        </Text>
      </Box>

      <Styles.StyledRadio checked={selected} />
    </Styles.Container>
  )
}
